// Types
import * as Types from '../types'
import {requestActionProps, requestGenerate} from '../../common'
import api from '../../../services/api'
import {callbackProps} from '../../../constants'

const actionGetHomeworkSessions = (
  payload: any,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.REQUEST),
  api: api.getHomeworkSession,
  payload: {data: new URLSearchParams(payload)},
  callback,
})

export {
  actionGetHomeworkSessions,
}
